import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class DryerIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string,
        secondaryColor: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e',
        secondaryColor: '#fff'
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 234.03 300">
                <g fill={color}>
                    <path d="M0 287.19A12.81 12.81 0 0 0 12.81 300h219.48a12.81 12.81 0 0 0 12.81-12.81V66.6H0zM245.1 12.81A12.81 12.81 0 0 0 232.29 0H12.81A12.81 12.81 0 0 0 0 12.81v44.75h245.1z" />
                    <circle cx={169.94} cy={28.78} r={11.31} fill={secondaryColor} />
                    <circle cx={211.92} cy={28.78} r={11.31} fill={secondaryColor} />
                    <path
                        d="M122.55 93.2a90.1 90.1 0 1 0 90.14 90.14 90.09 90.09 0 0 0-90.14-90.14zm72.41 93.16l.79-3.05a73.21 73.21 0 1 1-73.2-73.22 73.21 73.21 0 0 1 73.21 73.21z"
                        fill={secondaryColor}
                    />
                    <path
                        d="M125.08 163a4.87 4.87 0 0 0-6.58.29 5 5 0 0 0-.63 6.74c.33.45.7.86 1.07 1.28.22.25.44.5.65.76 3.25 4.1 3.08 7.3-.58 11.05a43.51 43.51 0 0 0-3.46 3.88 16.38 16.38 0 0 0-3.78 10.18c0 5 3.23 11.63 7.06 14.58a5.21 5.21 0 0 0 3.18 1.09 5 5 0 0 0 3.51-1.42 5 5 0 0 0 .64-6.65 11.49 11.49 0 0 0-.91-1.09l-.35-.39c-3.92-4.62-3.78-7.8.54-12.17a31.13 31.13 0 0 0 4.81-6.16c4.51-7.81.82-16.97-5.17-21.97zM159.8 190.91c.32-.32.64-.65.95-1l.86-.92a25.36 25.36 0 0 0 2.39-2.75c6.31-8.79 2.64-18.33-3.8-23.89a5.09 5.09 0 0 0-7.18 7.15c.28.36.58.7.88 1s.43.48.63.73c3.26 4.07 3.12 7.28-.49 11.07l-.33.35a45.81 45.81 0 0 0-3.1 3.48 17 17 0 0 0-3.87 10.57v.09c.1 4.47 2 8.62 5.94 13a6 6 0 0 0 4.09 2.25h.24a4.53 4.53 0 0 0 3.07-1.22c2.26-2 2.34-5 .12-7.74a24 24 0 0 1-2.25-3c-1.7-2.92-1.54-5.2.57-7.88a16.3 16.3 0 0 1 1.28-1.29zM91.99 189.88l.85-.84a17.46 17.46 0 0 0 5.53-12.85c-.11-4.92-2.5-9.74-6.72-13.59a5.05 5.05 0 0 0-7.1.05 5 5 0 0 0-.32 7c.29.37.59.72.9 1.08a18.71 18.71 0 0 1 1.18 1.47c2.44 3.51 2.31 6.15-.45 9.41-.47.55-1 1.07-1.47 1.59s-1.12 1.17-1.65 1.78a18.12 18.12 0 0 0-4.84 11.86c.06 5.87 3.51 10.37 6.1 13.25a5.65 5.65 0 0 0 4.14 2 4.55 4.55 0 0 0 3-1.19c2.29-2 2.43-5 .36-7.53l-.3-.37a24.21 24.21 0 0 1-2.27-3.09 6.08 6.08 0 0 1 .64-7.6 32.51 32.51 0 0 1 2.42-2.43z"
                        fill={secondaryColor}
                    />
                </g>
            </svg>
        );
    }
}

export default withTheme(DryerIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/DryerIcon.js